var _rect, _rect2, _path, _mask, _path2, _path3, _rect3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZkfhe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 7.40608,
    width: 49.7722,
    height: 49.7722,
    rx: 8.05,
    fill: "#FD4C00",
    stroke: "#101010",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5649,
    y: 43.17,
    width: 15.9723,
    height: 15.9723,
    transform: "rotate(-135 18.5649 43.17)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3098 21.7986C36.81 21.7986 41.2688 26.2574 41.2688 31.7576C41.2688 37.2578 36.81 41.7166 31.3098 41.7166C25.8096 41.7166 21.3508 37.2578 21.3508 31.7576C21.3508 26.2574 25.8096 21.7986 31.3098 21.7986Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.6
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_3177_3523",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5064 25.0999L30.2837 31.8771L23.6163 38.5446C22.0202 36.7361 21.0518 34.3606 21.0518 31.7589C21.0518 29.2175 21.9759 26.8919 23.5064 25.0999Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5064 25.0999L30.2837 31.8771L23.6163 38.5446C22.0202 36.7361 21.0518 34.3606 21.0518 31.7589C21.0518 29.2175 21.9759 26.8919 23.5064 25.0999Z",
    fill: "#FD4C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5064 25.0999L23.9307 24.6756L23.4717 24.2166L23.0502 24.7102L23.5064 25.0999ZM30.2837 31.8771L30.7079 32.3014L31.1322 31.8771L30.7079 31.4529L30.2837 31.8771ZM23.6163 38.5446L23.1664 38.9416L23.589 39.4204L24.0405 38.9688L23.6163 38.5446ZM23.0821 25.5241L29.8594 32.3014L30.7079 31.4529L23.9307 24.6756L23.0821 25.5241ZM29.8594 31.4529L23.192 38.1203L24.0405 38.9688L30.7079 32.3014L29.8594 31.4529ZM24.0661 38.1475C22.5631 36.4445 21.6518 34.2089 21.6518 31.7589L20.4518 31.7589C20.4518 34.5124 21.4773 37.0277 23.1664 38.9416L24.0661 38.1475ZM21.6518 31.7589C21.6518 29.3657 22.5214 27.1771 23.9626 25.4895L23.0502 24.7102C21.4303 26.6068 20.4518 29.0694 20.4518 31.7589L21.6518 31.7589Z",
    fill: "black",
    mask: "url(#path-4-inside-1_3177_3523)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.3721,
    y: 13.1825,
    width: 12.2042,
    height: 12.2042,
    rx: 6.10212,
    transform: "rotate(-180 31.3721 13.1825)",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8701 5.09085V5.46412C22.8701 7.302 23.7657 9.0246 25.2701 10.0803C26.7745 9.0246 27.6701 7.302 27.6701 5.46412V5.09085C26.7058 5.07311 25.9553 4.77256 25.2701 4.08032C24.585 4.77256 23.8344 5.07311 22.8701 5.09085Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3782 6.29483L25.1408 7.53227L24.3983 6.78981",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZkfhe);
export default __webpack_public_path__ + "static/media/zkfhe.1a05edb63454f51305f7a9aa8ce1e0d1.svg";
export { ForwardRef as ReactComponent };